<details-page-layout [title]="clientStore.selectedClient()?.name || 'Client detail' " (back)="utils.navigateTo('/clients')" [gridClass]="'grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 p-5'">
@if (clientStore.selectedClient(); as client) {
    <client-form
      title="Update client"
      submitLabel="Save client"
      [busy]="clientStore.saving()"
      [readOnly]="!canUpdate()"
      [initialValue]="client"
      (submitted)="saveClient($event)" 
      [canToggleActive]="(client.isActive && canDeactivate()) || (!client.isActive && canActivate())"
      [clientIsBusy]="(clientStore.activating() || clientStore.deactivating())"
      (deactivateAction)="toggleClientActive(client)"/>

    <!-- @if ((client.isActive && canDeactivate()) || (!client.isActive && canActivate())) {
      <div class="flex justify-end gap-2">
        <button
          mat-stroked-button
          type="button"
          [disabled]="clientStore.activating() || clientStore.deactivating()"
          (click)="toggleClientActive(client)">
          @if (clientStore.activating() || clientStore.deactivating()) {
            <mat-spinner diameter="20" class="mr-2" />
          }

          {{ client.isActive ? 'Deactivate' : 'Activate' }}
        </button>
      </div>
    } -->
    <client-config-panel
      detailsTitle="Client configurations"
      [canManage]="canUpdate()"
      [data]="clientStore.configurations()"
      (manageConfiguration)="manageConfiguration($event)" />
    <div class="col-span-1 lg:col-span-2 xl:col-span-1">
      <client-detail-panels
        detailsTitle="Client companies"
        /* [clientId]="clientId" */
        [canManage]="canUpdate()"
        [data]="clientStore.clientCompanies()"
        [companies]="clientStore.companies()"
        (companyFilterChanged)="filterClientCompanies($event)"
        (manageDetails)="manageClientCompany($event)" />
    </div>
  } @else {
    <mat-card class="p-5">
      <p class="text-sm">Client data is loading or was not found.</p>
    </mat-card>
  }
  <div class="col-span-1 lg:col-span-2 xl:col-span-3 overflow-auto pb-1">
      <history-list
        title="Client transaction history"
        emptyLabel="No history found for this client."
        [history]="clientStore.history()" />
  </div>
      <!-- (manageDetails)="manageConfiguration($event)" /> -->
</details-page-layout>
